import React from 'react';
import { Grid, Message, Segment, Table, Image, List } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { Dimmer, Loader, Divider } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import logo from "../../images/logo/logo-full-black.png";
import defaultLogo from '../../images/logo/logo-128.png'
import ModalHeader from './../drive/ModalHeader';
import mailImage from "../../images/grafix-banner/gfx-account-success.svg";
import gfxContactImage from "../../images/grafix-banner/gfx-contact.svg";
import gfxHackerImage from "../../images/grafix-banner/gfx-hacker.svg"
import MomentDate from './../common/MomentDate'
import MomentTime from './../common/MomentTime'
import EllipsisTooltip from './../common/EllipsisTooltip'
import camelCaseCovert from '../../helpers/convert-camel-case'
import AlreadyInviteAccepted from './../drive/Components/AlreadyInviteAccepted';
import ImageAvater from '../drive/Components/ImageAvater';
import {Icon } from 'semantic-ui-react'

const InvalidInvitationIdMsg = (props) => (
    <div>
        {props.error.name === 'NotFound' ?
            <Message negative
                icon='exclamation triangle'
                header="This invite does not exists."
            /> : props.error.message === 'You already accepted Invitation' ?
                <AlreadyInviteAccepted /> :
                <Message negative
                    icon='exclamation triangle'
                    header={props.error.message}
                />
        }
    </div>
)

const ThankYouMsgForm = () => (
    <div>

        <Message negative
            icon='thumbs up outline'
            header='This invite has been declined.'
        />
    </div>
)

const InvitationMsgForm = (props) => (
    <Segment as={Form} noValidate error ref={ref => this.form = ref} >

        <List verticalAlign='middle' className="display-block f_18">
            <List.Item>
                <Image
                    className="brandImage"
                    src={props.invitationData && props.invitationData.accountLogo ? props.invitationData.accountLogo : defaultLogo}
                />
                <List.Content >
                    <List.Header>
                        {props.invitationData.accountName + ' '}
                    </List.Header>
                </List.Content>
            </List.Item>
        </List>
        <p className='error_text1'> You have the following invitations.</p>
        <Table unstackable celled className="semantic-table">
            <Table.Header className="table-header">
                <Table.Row>
                    <Table.HeaderCell width={5}>Invited By</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Role</Table.HeaderCell>
                    <Table.HeaderCell width={5}>Invited to Join</Table.HeaderCell>
                    <Table.HeaderCell width={3}>Invited on</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body className="table-body">
                {props.invitationData.allInvitionsForEmail &&
                    props.invitationData.allInvitionsForEmail.map(function (inviteuser, index) {
                        return (
                            <Table.Row key={index}>
                                <Table.Cell >
                                    <List verticalAlign='middle'>
                                        <List.Item>
                                            <ImageAvater user={inviteuser.from} className="pad_tb_9" />
                                            <div className="float-left mar_tb_7">
                                                <EllipsisTooltip
                                                    name={inviteuser.from.firstName + ' ' + inviteuser.from.lastName}
                                                    line="2" />
                                            </div>
                                        </List.Item>
                                    </List>
                                </Table.Cell>
                                <Table.Cell >{inviteuser.role === "user" ? "Account user" : <span className="text-capitalize">{camelCaseCovert(inviteuser.role)}</span>}</Table.Cell>
                                <Table.Cell >
                                    <span className="f_10">{inviteuser.referenceCollection === 'accounts' ? 'Account' :
                                        inviteuser.referenceCollection === 'organizations' ? 'Workspace' :
                                            inviteuser.referenceCollection === 'suborganizations' ? 'Team' :
                                                inviteuser.referenceCollection === 'practices' ? 'Playbook' : ''}
                                    </span> <br />
                                    {inviteuser && inviteuser.referenceId && inviteuser.referenceId.name ? inviteuser.referenceId.name + ' ' : ' '}
                                </Table.Cell>
                                <Table.Cell ><MomentDate className="f_10" date={inviteuser.updatedAt} /> <br />
                                    at <MomentTime date={inviteuser.updatedAt} /> </Table.Cell>
                            </Table.Row>
                        );
                    }, this)}
            </Table.Body>
        </Table>
        <Divider />
        <div className="" style={{ display: 'flex', justifyContent: 'center', gap: '10px', alignItems: 'center' }}>
            <Button className="button-cancel" onClick={props.declineAction} id='declineBtn'>DECLINE</Button>
            <Button style={{ margin: "0" }} className="button-submit" onClick={props.acceptAction} id='acceptBtn'>ACCEPT</Button>
        </div>
    </Segment>
)

class RegisterUser extends React.Component {

    render() {

        let error = {}
        if (this.props.registrationError === 'Subscription does not exists' || this.props.registrationError === 'Customer does not exists') {
            error.name = "Something's wrong"
            error.image = gfxHackerImage
            error.subHeader1 = "Invalid URL"
            error.colorClass = "clr-orange"
            error.subHeader2 = <p>Looks like you tried accessing a page that does not exists. <br /> If you accidentaly came here, go back to <a href="http://aspenify.com/" className="clr-blue"> aspenify.com </a></p>
        } else if (this.props.registrationError === 'Error while creating account user') {
            error.name = "An error has occured while generating your login details"
            error.image = gfxContactImage
            error.subHeader1 = "Contact Us"
            error.colorClass = "clr-orange"
            error.subHeader2 = <p>We keep track of errors and will let you know what went wrong.
            <br /> Contact us to get your login details.
            <br /> E-Mail:<a href="mailto:platformadmin@aspenify.com" target="_blank">platformadmin@aspenify.com</a>
                <br /> Phone:+12 345 67890</p>
        } else if (this.props.registrationError === 'Email already exists') {
            error.name = "You do not need to reload the page/URL"
            error.image = mailImage
            error.subHeader1 = "Account already created"
            error.colorClass = "clr-green"
            error.subHeader2 = <p>The account has already been created.<br /> Please check your e-mail for login details.</p>
        }
        else if (this.props.registrationError === 'Success') {
            error.name = "Thanks for accepting invitation"
            error.image = mailImage
            error.subHeader1 = "Check your email"
            error.colorClass = "clr-green"
            error.subHeader2 = <p>We have sent your login details on <br /> {this.props.emailId}</p>
        }
        else {
            error.name = "An error has occured while generating your login details"
            error.image = gfxContactImage
            error.subHeader1 = "Contact Us"
            error.colorClass = "clr-orange"
            error.subHeader2 = <p>We keep track of errors and will let you know what went wrong.
            <br /> Contact us to get your login details.
            <br /> E-Mail:<a href="mailto:platformadmin@aspenify.com" target="_blank">platformadmin@aspenify.com</a>
                <br /> Phone:+12 345 67890</p>
        }

        return (
            <div>
                <p className="error_text1">{error.name}</p>
                <div ><img src={error.image} height="160" alt='' /> </div>
                <div className={` error_text2 ${error.colorClass}`}>{error.subHeader1}</div><br />
                <span className="error_text3">{error.subHeader2}</span>
            </div>
        );
    }
}

class Invite extends React.Component {
    constructor(props) {
        super(props);
        this.handleApprove = this.handleApprove.bind(this);
        this.handleDecline = this.handleDecline.bind(this);
        this.setCaptchaResponse = this.setCaptchaResponse.bind(this);
    }

    handleApprove() {
        let checkIfManager = false;
        let checkIfExecutive = false;
        if (this.props.invitationData.allInvitionsForEmail.length) {
            for (let i = 0; i < this.props.invitationData.allInvitionsForEmail.length; i++) {
                if (this.props.invitationData.allInvitionsForEmail[i].role === 'Manager') {
                    checkIfManager = true;
                }
                if (this.props.invitationData.allInvitionsForEmail[i].role === 'workspaceOwner') {
                    checkIfExecutive = true;
                }
            }
        }
        if (checkIfExecutive) {
            this.props.invitationData.role = 'workspaceOwner'
        }
        else if (checkIfManager && !checkIfExecutive) {
            this.props.invitationData.role = 'Manager'
        }
        else {
            this.props.invitationData.role = 'Member'
        }
        dispatch.invite.approveInviteAsync(this.props.invitationData);
    }

    handleDecline() {
        dispatch.invite.declineInviteAsync(this.props.invitationData);
    }

    setCaptchaResponse(response) {
        dispatch.invite.setCaptchaResponse(response);
    }

    componentDidMount() {
        dispatch.invite.getInviteDetailsAsync(this.props.match.params.id);
    }
    componentWillMount() {
        dispatch.app.cacheCleanup();
        dispatch.login.captchaCheck();
    }

    render() {
        let activeComponent = null;
        if (this.props.invitationData) {
            if (this.props.state === 0) {
                activeComponent = <InvitationMsgForm acceptAction={this.handleApprove} declineAction={this.handleDecline} invitationData={this.props.invitationData} />;
            }

            if (this.props.state === 1) {
                activeComponent = <RegisterUser registered={this.props.registered}
                    registrationError={this.props.registrationError} emailId={this.props.emailId}
                    firstName={this.props.firstName} lastname={this.props.lastname} />
            }
        }

        if (this.props.state === 2) {
            activeComponent = <ThankYouMsgForm />
        }
        if (this.props.invitationError) {
            activeComponent = <InvalidInvitationIdMsg error={this.props.invitationError} />;
        }
        return (
            <div className="inner">

                <ModalHeader
                    header={
                        // <img src={logo} alt='' />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
                                <img src={logo} alt="" style={{ flexShrink: 0 }} />
                            </div>
                                <div style={{ marginLeft: 'auto' }}>
                                   <Icon name="close" onClick={() => this.props.history.push('/login')} />
                                </div>
                            </div>
                    }
                />
                <div className="ModalContent">
                    <Grid padded={true} >
                        <Dimmer inverted active={this.props.loading} page={true}>
                            <Loader size='massive'>Loading Invitation Data</Loader>
                        </Dimmer>
                        <Dimmer inverted active={this.props.invitaionApproveloader} page={true}>
                            <Loader size='massive'>Please wait...</Loader>
                        </Dimmer>
                        <Dimmer inverted active={this.props.invitaionDeclineloader} page={true}>
                            <Loader size='massive'>Please wait...</Loader>
                        </Dimmer>
                        <Grid.Column width={16} className="pad_0">
                            {activeComponent}
                        </Grid.Column>
                    </Grid>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    const { registered, registrationError, emailId, firstName, lastname } = state.registerAccount;
    return {
        loading: state.loading.effects.invite.getInviteDetailsAsync,
        invitaionApproveloader: state.loading.effects.invite.approveInviteAsync,
        invitaionDeclineloader: state.loading.effects.invite.declineInviteAsync,
        invitationError: state.invite.invitationError,
        invitationData: state.invite.invitationData,
        state: state.invite.state,
        registered, registrationError, emailId, firstName, lastname,
    };
}

const connectedInvitePage = connect(mapStateToProps)(Invite);

export { connectedInvitePage as Invite }; 